












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CourseAspect, SelectOption, TocItem } from '@/app/shared/models';
import { getPageLocationByHref } from '@/app/shared/utils/route-utils';
import ChapterSelectComponent from '@/app/sidebar-navigation/components/chapter-select-component.vue';
import rootModule from '@/app/shared/state/root';
import aspectStoreModule from '@/app/aspect/apsect-state';
import SidebarNavigationItemComponent from '@/app/sidebar-navigation/components/sidebar-navigation-item-component.vue';
import UiStatusBarComponent from '@/app/shared/components/ui/ui-status-bar-component.vue';
import sectionCompletionStoreModule from '@/app/statistics/state/section-completion-state';
import { restrictedThemes } from '@/app/shared/utils'

@Component({
  components: {
    ChapterSelectComponent, SidebarNavigationItemComponent, UiStatusBarComponent
  }
})
export default class SidebarNavigationComponent extends Vue {
  @Prop()
  public courseAspect: CourseAspect;

  @Prop()
  public currentSection: TocItem;

  public selectedChapterInternal: TocItem|null = this.selectedChapter === null
    ? null
    : { ...this.selectedChapter };

  public isMobile = false

  private showNistifyThemeElements: boolean = false;

  public get sidebarIsOpen(): boolean {
    return rootModule.sidebarIsOpen;
  }

  public set sidebarIsOpen(value: boolean) {
    rootModule.setSidebarIsOpen(value);
  }

  public get courseTitle(): string {
    return this.courseAspect.title;
  }

  public get topTocOptions(): SelectOption[] {
    let options: SelectOption[] = [];
    this.courseAspect.tocItems.forEach((item: TocItem) => {
      options = [...options, {
        value: item.id,
        label: item.title,
        percent: item.percent ? item.percent : 0
      }];
    });

    return options;
  }

  public get subTocItems(): TocItem[] {
    if (this.selectedChapterInternal !== null && this.selectedChapterInternal.children) {
      return this.selectedChapterInternal.children;
    }

    return [];
  }

  private get selectedChapter(): TocItem|null {
    return aspectStoreModule.selectedChapter;
  }

  @Watch('selectedChapter')
  public onSelectedChapterChanged(newValue: TocItem): void {
    this.selectedChapterInternal = newValue;
  }

  public onTopItemSelected(event: SelectOption): void {
    this.courseAspect.tocItems.forEach((item: TocItem) => {
      if (event.value === item.id) {
        this.selectedChapterInternal = item;
        this.closeSidebarOnMobile()
        const page: string|null = this.getFirstPageUnderSection(item);
        if (page !== null) {
          this.$router.push(getPageLocationByHref(page));
        }
      }
    });
  }

  private getFirstPageUnderSection(chapter: TocItem): string|null {
    if (chapter.href) {
      return chapter.href;
    }

    if (!chapter.children) {
      return null;
    }

    for (const child of chapter.children) {
      const found: string|null = this.getFirstPageUnderSection(child);
      if (found !== null) {
        return found;
      }
    }

    return null;
  }

  public get courseTotalPercent(): number {
    return sectionCompletionStoreModule.totalPercent;
  }

  public checkMobile(): void {
    this.isMobile = window.innerWidth <= 1024
  }

  public closeSidebarOnMobile(): void {
    if (this.isMobile && this.sidebarIsOpen) {
      rootModule.setSidebarIsOpen(false)
    }
  }

  public mounted() {
    this.checkMobile()
    window.onresize = () => this.checkMobile()

    if (restrictedThemes(['nistify'])) {
      this.showNistifyThemeElements = true;
    }
  }

  public beforeDestroy() {
    window.onresize = () => {}
  }
}
